export const BasicInfoItems = {
  ProfilhePhoto: 'Profile photo',
  Role: 'Role',
  Province: 'Province',
};

export const ConnectionsTypes = {
  Connected: 'Connected',
  ReceivedRequests: 'Received requests',
  SentRequests: 'Sent requests',
};

export type CommunityRouteState = {
  activeTabIndex?: number;
  isFromDashboard?: boolean;
  isFromAboutPage?: boolean;
};
